import React from 'react';
import { useResearchDemo } from '../../contexts/ResearchDemoContext';
import type { QueueFilter } from '../../types/researchDemo';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { focusRing, secondaryButton } from '../../utils/demoUi';
import { statusLabels } from '../../utils/researchDemo';
import { ClaimCard } from './ClaimCard';
const filters: {
  id: QueueFilter;
  label: string;
}[] = [{
  id: 'all',
  label: 'All records'
}, {
  id: 'proposed',
  label: statusLabels.proposed
}, {
  id: 'approved',
  label: statusLabels.approved
}, {
  id: 'revision-requested',
  label: statusLabels['revision-requested']
}, {
  id: 'rejected',
  label: statusLabels.rejected
}];
export function ReviewQueue() {
  const {
    state,
    dispatch,
    openClaim
  } = useResearchDemo();
  const filter = state.ui.queueFilter;
  const count = (id: QueueFilter) => id === 'all' ? state.claims.length : state.claims.filter(claim => claim.status === id).length;
  const visible = filter === 'all' ? state.claims : state.claims.filter(claim => claim.status === filter);
  return <div data-id="element-2313" data-mp="1cmrovoiup0eb">
      <DemoSectionHeader title="Review Queue" description="Check each relationship against its cited passage. Only approved records enter the researcher’s knowledge map." data-id="element-2314" data-mp="1cmi90tris9mc" />
      <div role="group" aria-label="Filter records by status" className="mb-6 flex flex-wrap gap-2" data-id="element-2315" data-mp="1lf23di0s3s1d">
        {filters.map(item => {
        const current = item.id === filter;
        return <button key={item.id} type="button" aria-pressed={current} onClick={() => dispatch({
          type: 'setQueueFilter',
          filter: item.id
        })} className={`rounded-full border px-3.5 py-1.5 text-sm font-semibold whitespace-nowrap transition-colors duration-150 ${focusRing} ${current ? 'border-navy bg-navy text-white' : 'border-line bg-white text-ink-dark hover:bg-surface-muted'}`} data-id="element-2316" data-mp="1vczmjr3s6yn4">
              {item.label} <span className={current ? 'text-white/75' : 'text-ink-muted'} data-id="element-2317" data-mp="1daaqwnlikqv9">{count(item.id)}</span>
            </button>;
      })}
      </div>

      {visible.length === 0 ? <p className="rounded-xl border border-line bg-white/80 p-8 text-center text-ink-muted" data-id="element-2318" data-mp="1mb8w397ov4ff">No records with this status.</p> : <ul className="grid grid-cols-1 gap-4 md:grid-cols-2 2xl:grid-cols-3" data-id="element-2319" data-mp="1i9456i8mklwh">
          {visible.map(claim => <li key={claim.id} data-id="element-2320" data-mp="1w7u1vwrj8jkb">
              <ClaimCard claim={claim} actionLabel="Review evidence record" onOpen={openClaim} data-id="element-2321" data-mp="1ralg7m76dxeb" />
            </li>)}
        </ul>}
    </div>;
}
export function ApprovedKnowledge() {
  const {
    state,
    openClaim,
    goTo
  } = useResearchDemo();
  const approved = state.claims.filter(claim => claim.status === 'approved');
  return <div data-id="element-2322" data-mp="2f0xy9pw4xaim">
      <DemoSectionHeader title="Approved Knowledge" description="Relationships currently published to the knowledge map, each with its interpretation limits and version." actions={<button type="button" onClick={() => goTo('research', 'map')} className={secondaryButton} data-id="element-2324" data-mp="2tno9biznuhhe">
            View in Knowledge Map
          </button>} data-id="element-2323" data-mp="2f0pjttkd5x5b" />
      {approved.length === 0 ? <p className="rounded-xl border border-line bg-white/80 p-8 text-center text-ink-muted" data-id="element-2325" data-mp="2klx7ip88qust">
          No relationships are approved. Review proposals in the Review Queue.
        </p> : <ul className="grid grid-cols-1 gap-4 md:grid-cols-2 2xl:grid-cols-3" data-id="element-2326" data-mp="2av2ijd3m1h3o">
          {approved.map(claim => <li key={claim.id} data-id="element-2327" data-mp="2fox1gebe5s1p">
              <ClaimCard claim={claim} actionLabel="Open evidence record" onOpen={openClaim} data-id="element-2328" data-mp="20yz4p9zebu0w" />
            </li>)}
        </ul>}
    </div>;
}